import { Injectable } from '@angular/core';
import { TermsAndConditionsType, TermsAndConditionModel, TermsAndCondition } from '@models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TermsConditionService {
  getTermsAndConditions() {
    return http$.get('/App/GetTermsAndConditions/');
  }
  updateTermsAndConditions(dto: TermsAndConditionModel): Observable<string> {
    const payload = {
      type: dto.type,
      value: {
        arabic: dto.value.arabic,
        english: dto.value.english
      }
    };
    return http$.put<string>('/AdminPanel/UpdateTermsAndConditions', payload);
  }
  getTermsAndConditionForAdmin(type: TermsAndConditionsType): Observable<TermsAndCondition> {
    return http$.get<TermsAndCondition>(`/AdminPanel/GetTermsAndConditionForAdmin?Type=${type}`);
  }
  getPrivacyPolicy() {
    return http$.get('/App/GetPrivacyPolicy');
  }
  GetDelivery() {
    return http$.get('/App/GetDelivery');
  }
}
